import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, Row, Typography } from 'antd';
import { Container } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { ScaleLoader } from 'react-spinners';
import { useNavigate } from 'react-router-dom';
import logo from "../../assets/logomain.png";
import moment from 'moment';
import { getProfileData } from '../../redux/actions/profileAction';
import { cancelSubsciption } from '../../redux/actions/authAction';
import { stripePromise } from '../../redux/constants/stripekey';
import { Elements } from '@stripe/react-stripe-js';
import AcademyPriceCard from './AcademyPriceCard';
import { loadStripe } from '@stripe/stripe-js';
import { toast } from 'react-toastify';
import CardInfo from './CardInfo';

const AcadenyInnerPurchase = () => {
    // const { addToast } = useToasts();
    const currencyData = localStorage.getItem("currency_data");
    const token = useSelector((state) => state.authReducer.isLoggedIn);
    const stripeKey = loadStripe(stripePromise);
    const userData = useSelector((state) => state?.profileReducer?.user_data);
    const cardDetail = userData?.stripeCustomerDetail?.default_source;
    const newCardDetail = userData?.stripeCustomerDetail;

    console.log(newCardDetail, 'newCardDetail')

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loadingBars, setLoadingBars] = useState(false);
    const [cancelModal, setCancelModal] = useState(false);
    const [cancelMessageModal, setCancelMessageModal] = useState(false);
    const [cancelledModal, setCancelledModal] = useState(false);

    const [isSubCancelled, setIsCancelled] = useState(0);
    const [endTrialDate, setEndTrialDate] = useState(false);
    const [subscriptionStatus, setSubscriptionStatus] = useState('inactive');
    const [cancelDate, setCancelDate] = useState('');
    const [purchaseDate, setPurchaseDate] = useState('');
    const [platForm, setPlatForm] = useState('');
    const [durationDays, setDurationDays] = useState('');
    const [cancelSubs, setCancelSubs] = useState(true);
    const [paymentModal, setPaymentModal] = useState(false);

    const checkSubscription = () => {

        let currentDate = moment().unix() * 1000;
        let cancelSubs = userData?.user_subscription?.cancelled_on

        let trialStartDate = userData?.user_subscription?.trial_start_date?.toString().length > 10 ? userData?.user_subscription?.trial_start_date : userData?.user_subscription?.trial_start_date * 1000;

        let trialEndDate = userData?.user_subscription?.trial_end_date?.toString().length > 10 ? userData?.user_subscription?.trial_end_date : userData?.user_subscription?.trial_end_date * 1000;

        let nextPaymentDate = userData?.user_subscription?.next_payment_date?.toString().length > 10 ? userData?.user_subscription?.next_payment_date : userData?.user_subscription?.next_payment_date * 1000;

        let cancelledDate = userData?.user_subscription?.cancelled_on?.toString().length > 10 ? userData?.user_subscription?.cancelled_on : userData?.user_subscription?.cancelled_on * 1000;

        let purchasedDate = userData?.user_subscription?.purchased_on?.toString().length > 10 ? userData?.user_subscription?.purchased_on : userData?.user_subscription?.purchased_on * 1000;
        let durationInDays = userData?.user_subscription?.plan_id?.duration_in_days;

        let platform = userData?.user_subscription?.platform;
        // setIsCustomTrial(userData?.user_subscription?.custom_trial ?? 0);

        const purchasedDateDiff = moment().diff(purchasedDate, 'days');
        if (cancelledDate > purchasedDate) {
            setIsCancelled(1)
        }
        if (currentDate <= trialEndDate) {
            setSubscriptionStatus('trial')
        } else if (purchasedDateDiff < durationInDays) {
            setSubscriptionStatus('active')
        } else {
            if (nextPaymentDate && (nextPaymentDate > currentDate)) {
                setSubscriptionStatus('active')
            }
        }

        setEndTrialDate(trialEndDate)
        setCancelDate(cancelledDate)
        setPurchaseDate(purchasedDate)
        setPlatForm(platform)
        setDurationDays(durationInDays)
    }

    useEffect(() => {
        checkSubscription();
    }, [])

    const handleCancelledModal = () => {
        setCancelledModal(true)
    }

    const handleCancelModal = () => {
        setCancelModal(true)
    }

    const handleCancelSubscription = () => {
        setCancelModal(false)
        setLoadingBars(true)
        const successCb = (res) => {

            setLoadingBars(false)
            setCancelMessageModal(true)
            dispatch(getProfileData())
            setCancelSubs(false)
        }
        const failureCb = (res) => {
            toast.error(res?.data?.message, { appearance: "error", autoDismiss: true })
            setLoadingBars(false)
            setCancelMessageModal(false)
        }
        dispatch(cancelSubsciption(successCb, failureCb))
    }

    let purchasedDate = userData?.user_subscription?.purchased_on?.toString().length > 10 ? userData?.user_subscription?.purchased_on : userData?.user_subscription?.purchased_on * 1000;
    let durationInDays = userData?.user_subscription?.plan_id?.duration_in_days;
    let purchasedDateDiff = moment().diff(purchasedDate, 'days')


    useEffect(() => { window.scrollTo(0, 0); }, [])

    return (
        <>
            <div className="common_background">
                <Container fluid className='fluid_content'>
                    <div style={{ minHeight: "50vh" }}>
                        {purchasedDateDiff > durationInDays ?
                            <>
                                <Row>
                                    <Col className='mx-auto'>
                                        <div className="text-center mb-4">
                                            <Typography className='big_font'>Academy Subscription</Typography>
                                            <Typography className='normal_font pt-2'>Access all Programs, BP Community and Member Benefits</Typography>
                                            <Typography className='normal_font pb-3'>Become an Academy User today and give your students the benefits of the Bulletproof For BJJ program</Typography>
                                        </div>
                                        <Elements stripe={stripeKey}>
                                            <AcademyPriceCard loadBar={setLoadingBars} userId={userData?._id} />
                                        </Elements>
                                    </Col>
                                </Row>
                            </>
                            :
                            <Col xs={24} sm={24} md={24} lg={10} xl={7} xxl={7} className="mx-auto">
                                <Typography className="big_font mb-4 text-center">Academy Subscription</Typography>
                                <div className="active_subs_div">
                                    <div className="text-center">
                                        <Typography className='small_font'>Active Plan</Typography>
                                    </div>
                                    <div className="annual_card mt-3" style={{ border: "2px solid #ae841e" }}>
                                        <div className="">
                                            <div className="d-flex align-items-center">
                                                <Typography className="small_font">{userData?.user_subscription?.plan_id?.plan_name}</Typography>
                                            </div>
                                            {userData?.user_subscription?.cancelled_on == 0 ?
                                                <Typography className="normal_font mt-1">Billed each {userData?.user_subscription?.plan_id?.stripe_package_name == "monthly_academy" ? "month" : "year"} for active users</Typography>
                                                :
                                                <Typography className="normal_font mt-1">No Further Payment</Typography>
                                            }
                                        </div>
                                        <div className="price_">
                                            <Typography className="small_font text-end" style={{ color: "#ae841e" }}>USD {userData?.user_subscription?.plan_id?.amount}</Typography>
                                            <Typography className="normal_font text-end">Per Month</Typography>
                                        </div>
                                    </div>

                                    {cancelDate && cancelDate > purchaseDate ? null : cancelSubs == true ?
                                        <div className="mt-2 d-flex align-items-center justify-content-between">
                                            <Typography className="normal_font">Date of next payment</Typography>
                                            <Typography className="so_snall_font">
                                                {moment(purchaseDate).add(durationDays + 1, 'day').format('ll')}
                                            </Typography>
                                        </div> : ""}

                                    <div className="mt-5 text-center">
                                        {platForm == "stripe" ? userData?.user_subscription?.cancelled_on !== 0 ? <Button onClick={() => handleCancelledModal()} className='common_btn common_btn_color w-100 px-0'>Subscription Cancelled</Button> : <Button className='common_btn w-100 px-0' onClick={() => handleCancelModal()}>Cancel Subscription</Button> : ""}
                                    </div>
                                </div>

                                {cardDetail &&
                                    <div className="active_subs_div mt-4 p-3">
                                        <div className="d-flex justify-content-between mb-3">
                                            <div className="card_brand_div">
                                                <span className="big_font text-white">{cardDetail?.brand?.toUpperCase()}</span>
                                            </div>
                                            <Button onClick={() => setPaymentModal(true)} className="common_btn px-2" style={{ height: '30px', background: '#1F1F1F' }}>Update</Button>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <dt className="small_font">XXXX XXXX XXXX {cardDetail?.last4}</dt>
                                            <dt>Expires {cardDetail?.exp_month}/{cardDetail?.exp_year}</dt>
                                        </div>
                                    </div>
                                }
                                {newCardDetail?.cardList?.length > 0 &&
                                    <div className="active_subs_div mt-4 p-3">
                                        <div className="d-flex justify-content-between mb-3">
                                            <div className="card_brand_div">
                                                <span className="big_font text-white">{newCardDetail?.cardList?.[0]?.card?.brand?.toUpperCase()}</span>
                                            </div>
                                            <Button onClick={() => setPaymentModal(true)} className="common_btn px-2" style={{ height: '30px', background: '#1F1F1F' }}>Update</Button>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <dt className="small_font">XXXX XXXX XXXX {newCardDetail?.cardList?.[0]?.card?.last4}</dt>
                                            <dt>Expires {newCardDetail?.cardList?.[0]?.card?.exp_month}/{newCardDetail?.cardList?.[0]?.card?.exp_year}</dt>
                                        </div>
                                    </div>
                                }
                                {newCardDetail?.cardList?.length > 0 || cardDetail ? "" : <Button onClick={() => setPaymentModal(true)} className='common_btn common_btn_color w-100 px-0 mt-3'>Add Card</Button>}
                            </Col>
                        }
                    </div>
                </Container>
            </div>

            <ScaleLoader
                color='#ae841e'
                loading={loadingBars}
                style={{ background: "rgba(0, 0, 0, 0.155)", height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", position: "fixed", width: "100%", top: "0" }}
            />

            {/* Cancel Modal */}
            <Modal closable={false} open={cancelModal} onOk={handleCancelSubscription} onCancel={() => setCancelModal(false)} >
                <p className="trial_font">Are you sure you want to cancle your BJJ subscription?</p>
            </Modal>

            {/*Cancel subs Message Modal*/}
            <Modal
                open={cancelMessageModal}
                onCancel={setTimeout(() => { setCancelMessageModal(false) }, 3000)}
                footer={null}
                closable={false}
            >
                <div className="text-center">
                    <img src={logo} alt="successGif" width={"50%"} />
                    <Typography className='small_font pt-3'>Subscription Cancelled</Typography>
                </div>
            </Modal>

            {/*Cancelled Message Modal*/}
            <Modal
                open={cancelledModal}
                onCancel={() => setCancelledModal(false)}
                footer={null}
            // closable={false}
            >
                <div className="text-center">
                    <img src={logo} alt="successGif" width={"40%"} />
                    <Typography className='small_font py-4' style={{ fontWeight: "normal" }}>Subscription Already Cancelled On <br /> {moment(userData?.user_subscription?.cancelled_on * 1000).format('ll')}</Typography>
                    {/* <Button onClick={() => setCancelledModal(false)} className='common_btn px-3'>OKAY</Button> */}
                </div>
            </Modal>

            <Modal
                open={paymentModal}
                onCancel={() => setPaymentModal(false)}
                footer={null}
            >
                <Elements stripe={stripeKey}>
                    <CardInfo setPaymentModal={setPaymentModal} />
                </Elements>
            </Modal>
        </>
    )
}

export default AcadenyInnerPurchase;





